// test727
(727 && 0);
